const colorTable = {
  ncolors: 16,
  colorTable: [
    0.015686,
    0.054902,
    0.847059,
    0.12549,
    0.313725,
    1.0,
    0.254902,
    0.588235,
    1.0,
    0.427451,
    0.756863,
    1.0,
    0.52549,
    0.85098,
    1.0,
    0.611765,
    0.933333,
    1.0,
    0.686275,
    0.960784,
    1.0,
    0.807843,
    1.0,
    1.0,
    1.0,
    0.996078,
    0.278431,
    1.0,
    0.921569,
    0.0,
    1.0,
    0.768627,
    0.0,
    1.0,
    0.564706,
    0.0,
    1.0,
    0.282353,
    0.0,
    1.0,
    0.0,
    0.0,
    0.835294,
    0.0,
    0.0,
    0.619608,
    0.0,
    0.0
  ]
}

export default colorTable
